"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSfdcCampaigns = fetchSfdcCampaigns;
exports.fetchSfdcSettings = fetchSfdcSettings;
exports.FAIL_GETTING_SFDC_SETTINGS = exports.SUCCEED_GETTING_SFDC_SETTINGS = exports.RECEIVE_SFDC_SETTINGS = exports.REQUEST_SFDC_SETTINGS = exports.FAIL_GETTING_CAMPAIGNS = exports.SUCCEED_GETTING_CAMPAIGNS = exports.RECEIVE_CAMPAIGNS = exports.REQUEST_CAMPAIGNS = void 0;

var _SalesforceCampaigns = require("lead-flows-ui/api/SalesforceCampaigns");

function createAction(name) {
  return "@@salesforceCampaigns/" + name;
}

var REQUEST_CAMPAIGNS = createAction('REQUEST_CAMPAIGNS');
exports.REQUEST_CAMPAIGNS = REQUEST_CAMPAIGNS;
var RECEIVE_CAMPAIGNS = createAction('RECEIVE_CAMPAIGNS');
exports.RECEIVE_CAMPAIGNS = RECEIVE_CAMPAIGNS;
var SUCCEED_GETTING_CAMPAIGNS = createAction('SUCCEED_GETTING_CAMPAIGNS');
exports.SUCCEED_GETTING_CAMPAIGNS = SUCCEED_GETTING_CAMPAIGNS;
var FAIL_GETTING_CAMPAIGNS = createAction('FAIL_GETTING_CAMPAIGNS');
exports.FAIL_GETTING_CAMPAIGNS = FAIL_GETTING_CAMPAIGNS;
var REQUEST_SFDC_SETTINGS = createAction('REQUEST_SFDC_SETTINGS');
exports.REQUEST_SFDC_SETTINGS = REQUEST_SFDC_SETTINGS;
var RECEIVE_SFDC_SETTINGS = createAction('RECEIVE_SFDC_SETTINGS');
exports.RECEIVE_SFDC_SETTINGS = RECEIVE_SFDC_SETTINGS;
var SUCCEED_GETTING_SFDC_SETTINGS = createAction('SUCCEED_GETTING_SFDC_SETTINGS');
exports.SUCCEED_GETTING_SFDC_SETTINGS = SUCCEED_GETTING_SFDC_SETTINGS;
var FAIL_GETTING_SFDC_SETTINGS = createAction('FAIL_GETTING_SFDC_SETTINGS'); // Action creators

exports.FAIL_GETTING_SFDC_SETTINGS = FAIL_GETTING_SFDC_SETTINGS;

function requestCampaigns() {
  return {
    type: REQUEST_CAMPAIGNS
  };
}

function receiveCampaigns(campaigns) {
  return {
    type: RECEIVE_CAMPAIGNS,
    campaigns: campaigns
  };
}

function succeedGettingCampaigns() {
  return {
    type: SUCCEED_GETTING_CAMPAIGNS
  };
}

function failGettingCampaigns() {
  return {
    type: FAIL_GETTING_CAMPAIGNS
  };
}

function requestSfdcSettings() {
  return {
    type: REQUEST_SFDC_SETTINGS
  };
}

function receiveSfdcSettings(settings) {
  return {
    type: RECEIVE_SFDC_SETTINGS,
    settings: settings
  };
}

function succeedGettingSfdcSettings() {
  return {
    type: SUCCEED_GETTING_SFDC_SETTINGS
  };
}

function failGettingSfdcSettings() {
  return {
    type: FAIL_GETTING_SFDC_SETTINGS
  };
}

function fetchSfdcCampaigns() {
  return function (dispatch) {
    dispatch(requestCampaigns());
    return (0, _SalesforceCampaigns.getCampaigns)().then(function (response) {
      dispatch(succeedGettingCampaigns());
      dispatch(receiveCampaigns(response));
    }, function (error) {
      dispatch(failGettingCampaigns(error.xhr));
    }).done();
  };
}

function fetchSfdcSettings() {
  return function (dispatch) {
    dispatch(requestSfdcSettings());
    return (0, _SalesforceCampaigns.getSfdcSettings)().then(function (response) {
      dispatch(succeedGettingSfdcSettings());

      if (response.syncEnabled) {
        dispatch(fetchSfdcCampaigns());
      }

      dispatch(receiveSfdcSettings(response));
    }, function (error) {
      dispatch(failGettingSfdcSettings(error.xhr));
    }).done();
  };
}